import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2021-07-08'
        tag='Poshmark Snippets'
        title='What do I do with Single Item Bundles on Poshmark?'
      >
        <p> Did someone leave you hanging with a single listing in a bundle? Here's what it could mean.</p>

        <h4>They were browsing your closet, but got interrupted!</h4>
        <p> It's very easy to get distracted, it's entirely possible that they simply forgot about the bundle.</p>

        <h4>They were expecting a discount</h4>
        <p>It's also very possible that they were hoping for a discount as well.</p>

        <h3> What you can do? </h3>

        <h4> Make an offer! </h4>
        <p>
          {' '}
          Even though it's a single listing, you can still give a private discount to buyers without a public price
          drop!
        </p>
        <h4> Write a comment </h4>
        <p> Ask them to take another look at your closet and let them know of any bundle discounts you give!</p>

        <p> Best of luck, and happy selling!</p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
